import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customeMsZehutFilter'
})
export class CustomerMsZehutFilter implements PipeTransform {
    transform(value: any[], args: string): any {
        if (args) {
            return value.filter(order => order.ms_zehut == args);
        }
        else { return value; }
    }
}